module.exports = __webpack_public_path__ + "static/media/wrexham.a3a59225.webp";